var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "range-slider" }, [
    _c("div", { staticClass: "range-readout" }, [
      _c("span", [_vm._v(_vm._s(_vm.format(_vm.low)))]),
      _c("span", { staticClass: "range-readout-sep" }, [_vm._v("–")]),
      _c("span", [_vm._v(_vm._s(_vm.format(_vm.high)))]),
      !_vm.atFullExtent
        ? _c(
            "span",
            {
              staticClass: "range-reset",
              attrs: { title: "Reset to the full range" },
              on: {
                click: function ($event) {
                  return _vm.reset()
                },
              },
            },
            [_vm._v("reset")]
          )
        : _vm._e(),
    ]),
    _c("div", { staticClass: "range-track-area" }, [
      _c("div", { staticClass: "range-track" }),
      _c("div", { staticClass: "range-track-fill", style: _vm.fillStyle }),
      _c("input", {
        staticClass: "range-input",
        attrs: { type: "range", min: _vm.min, max: _vm.max, step: _vm.step },
        domProps: { value: _vm.low },
        on: {
          input: function ($event) {
            return _vm.onInput("low", $event)
          },
          change: function ($event) {
            return _vm.commit()
          },
        },
      }),
      _c("input", {
        staticClass: "range-input",
        attrs: { type: "range", min: _vm.min, max: _vm.max, step: _vm.step },
        domProps: { value: _vm.high },
        on: {
          input: function ($event) {
            return _vm.onInput("high", $event)
          },
          change: function ($event) {
            return _vm.commit()
          },
        },
      }),
    ]),
    _c("div", { staticClass: "range-extent" }, [
      _c("span", [_vm._v(_vm._s(_vm.format(_vm.min)))]),
      _c("span", [_vm._v(_vm._s(_vm.format(_vm.max)))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }